import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

export default function SponsorCard({ placement }) {
  const [sponsors, setSponsors] = useState(null);

  useEffect(() => {
    api.getSponsors(placement).then(setSponsors).catch(() => setSponsors([]));
  }, [placement]);

  if (!sponsors || sponsors.length === 0) return null;

  return (
    <div style={styles.wrap}>
      {sponsors.map((s) => (
        <a
          key={s.id}
          href={s.link_url || '#'}
          target={s.link_url ? '_blank' : undefined}
          rel={s.link_url ? 'noopener noreferrer' : undefined}
          style={styles.card}
          onClick={(e) => { if (!s.link_url) e.preventDefault(); }}
        >
          <span style={styles.badge}>Sponsored</span>

          <div style={styles.body}>
            {s.logo_url ? (
              <div style={styles.logoBox}>
                <img
                  src={s.logo_url}
                  alt={s.name}
                  style={styles.logoImg}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
            ) : (
              <div style={styles.logoFallback}>{s.name.charAt(0)}</div>
            )}
            <span style={styles.name}>{s.name}</span>
            {s.tagline && <span style={styles.tagline}>{s.tagline}</span>}
          </div>
        </a>
      ))}
    </div>
  );
}

const styles = {
  wrap: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '0.6rem',
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.25rem 1rem',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  badge: {
    fontSize: '0.6rem',
    fontWeight: '700',
    color: '#6b7280',
    border: '1px solid #374151',
    borderRadius: '4px',
    padding: '2px 8px',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontFamily: "'Syne', sans-serif",
    alignSelf: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.5rem',
  },
  logoBox: {
    width: '96px',
    height: '96px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    borderRadius: '16px',
    overflow: 'hidden',
    padding: '10px',
  },
  logoImg: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  logoFallback: {
    width: '96px',
    height: '96px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#1e2a3a',
    borderRadius: '16px',
    color: '#00d4aa',
    fontSize: '2.2rem',
    fontWeight: '800',
    fontFamily: "'Syne', sans-serif",
  },
  name: {
    color: '#e5e7eb',
    fontSize: '1rem',
    fontWeight: '700',
    fontFamily: "'Syne', sans-serif",
  },
  tagline: {
    color: '#6b7280',
    fontSize: '0.78rem',
    maxWidth: '280px',
  },
};
